import { ConfigSite } from "./models/configSite";
import { EnvType } from "./models/envType";

export const ConfigServer = (url: string) => {
  let currentConfigMode = EnvType.DEVELOPMENT;

  switch (url) {
    case "localhost":
      currentConfigMode = EnvType.PRODUCTION;//EnvType.LOCAL;

      break;
    case "release-sale-frontend-eshop.rc.eshop.aservices.tech":
      currentConfigMode = EnvType.RELEASE_CANDIDATE;

      break;
    case "master-sale-frontend-eshop.dev.eshop.aservices.tech":
      currentConfigMode = EnvType.DEVELOPMENT;

      break;
    case "sale-frontend-eshop.prod.eshop.aservices.tech":
      currentConfigMode = EnvType.PRODUCTION;

      break;
    case "sale2.action-press.ru":
      currentConfigMode = EnvType.PRODUCTION;

      break;
    case "sale.action-press.ru":
      currentConfigMode = EnvType.PRODUCTION;

      break;
    case "stable-sale-frontend-eshop.rc.eshop.aservices.tech":
      currentConfigMode = EnvType.STABLE;
      
      break;
    default:
      currentConfigMode = EnvType.DEVELOPMENT;

      break;
  }

  const config = new ConfigSite(currentConfigMode);

  return config;
};
